import type { Event } from '@/lib/events';

export type EventQuickActionId = 'edit' | 'share' | 'directions' | 'calendar';

export function canOfferEventEditAction({
  isCreator,
  isEditable,
  isGlobalAdmin,
  isTenantAdmin,
}: Readonly<{
  isCreator: boolean;
  isEditable: boolean;
  isGlobalAdmin: boolean;
  isTenantAdmin: boolean;
}>): boolean {
  return isEditable && (isCreator || isGlobalAdmin || isTenantAdmin);
}

export function eventQuickActionIds({
  editAvailable,
  status,
  tenantSlug,
}: Readonly<{
  editAvailable: boolean;
  status: Event['status'];
  tenantSlug?: string | null;
}>): EventQuickActionId[] {
  const actions: EventQuickActionId[] = [];

  if (editAvailable) {
    actions.push('edit');
  }

  if (status === 'published' && tenantSlug) {
    actions.push('share');
  }

  actions.push('directions');

  if (status === 'published') {
    actions.push('calendar');
  }

  return actions;
}
